import {
  validateMessagingTitleString,
  validateRequired,
  validateString,
  validationObject,
} from 'utils/validations';
export const getInitialValues = ({
  recipientId,
  recipientName,
  title,
  body,
}) => {
  let recipients = [];
  if (recipientId && recipientName) {
    recipients = [{ id: recipientId, label: recipientName }];
  }
  const initialValues = {
    recipients: recipients,
    title: title,
    body: body,
  };

  return { ...initialValues };
};

export const initialState = {
  body: '',
  recipients: [],
  title: '',
};
export const validationSchema = () =>
  validationObject({
    recipients: validateRequired(),
    body: validateString(250, true),
    title: validateMessagingTitleString(54),
    /**
     *FIXME the user can only type 50 characters the + 4 is for RE/FW
     */
  });
